<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
        <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      aliveTabs:['dailyTasks']
    }
  },
  mounted(){
  },
  beforeCreate () {
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('userMsg') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('userMsg'))))
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('userMsg', JSON.stringify(this.$store.state))
    })
  },
  methods:{
  }
}
</script>

<style>
body{
  margin:0px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue